module.exports = __webpack_public_path__ + "static/media/tca.d60a2028.svg";